module.exports = __webpack_public_path__ + "img/aopumai_gongzong.a99e810c.png";